export const GET_DATA_REQUEST = "GET_DATA_REQUEST";
export const GET_DATA_SUCCESS = "GET_DATA_SUCCESS";
export const GET_DATA_FAILURE = "GET_DATA_FAILURE";


export const GET_HOME_LOAD_REQUEST = "GET_HOME_LOAD_REQUEST";
export const GET_HOME_LOAD_SUCCESS = "GET_HOME_LOAD_SUCCESS";
export const GET_HOME_LOAD_FAILURE = "GET_HOME_LOAD_FAILURE";
